import { patchBodyContactDriverQueryFunctions } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyContactDriverData/patchBodyContactDriverQueryFunctions';

import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchBodyContactDriverParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyContactDriverData/patchBodyContactDriverQuery.type';

export const patchBodyContactDriverQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyContactDriverParamsType
> => ({
  mutationKey: ['PatchBodyCertificationQueryParamsType'],
  mutationFn: (params: PatchBodyContactDriverParamsType) =>
    patchBodyContactDriverQueryFunctions(params),
});
